import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "w-3/12 text-right flex-grow" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseStyle = _resolveComponent("BaseStyle")!

  return (_openBlock(), _createBlock(_component_BaseStyle, {
    model: _ctx.model,
    class: "content-base"
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.purchaseItems, (targetItem) => {
        return (_openBlock(), _createElementBlock("div", {
          key: targetItem.name,
          class: "flex px-5 pb-2 pt-6 items-start justify-between border-b"
        }, [
          _createElementVNode("div", {
            class: "w-9/12",
            textContent: _toDisplayString(targetItem.name)
          }, null, 8, _hoisted_1),
          _createElementVNode("div", _hoisted_2, _toDisplayString(targetItem.count) + _toDisplayString(targetItem.itemUnit), 1)
        ]))
      }), 128))
    ]),
    _: 1
  }, 8, ["model"]))
}